<script>
import {onMounted, onUnmounted, ref} from 'vue'
import circleAnimation from '@/components/ui/circle-animation.vue'
import nextArrow from '@/components/ui/next-arrow.vue'
import navigation from "@/components/navigation.vue";
import selfMedication from "@/components/self-medication.vue";


export default {
  components: {
    navigation,
    selfMedication,
    nextArrow,
    circleAnimation,
  },

  setup() {
    const contentItems = ref([
      {
        title: 'Спрямована',
        body: 'проти <b>найпоширенішого</b> в Україні та Європі збудника <b>менінгококової інфекції<sup>1,2</sup></b>'
      },
      {
        title: 'проводиться',
        body: 'в країнах <b>ЄС</b>&nbsp;та&nbsp;<b>США<sup>3,4</sup>'
      },
      {
        title: 'Актуальна<br>для дітей<br>',
        body: '<b>і дорослих</b><sup>3</sup>'
      }
    ])

    return {contentItems}
  }
}
</script>

<template>
  <section class="section section1" id="section1">

    <div class="content">
      <div class="content__left">

        <div class="content__message ">

          <div class="content__message-icon">
            <circleAnimation/>
          </div>

          <p class="content__message-text">Інформація для <b class="content__mfge-accent">батьків із безкомпромісним
            підходом до захисту дітей</b> від інфекційних захворювань</p>
        </div>

        <h1 class="content__title js-scroll scrolled fade-in-title">
          <span class="animation-title ">ПРОФІЛАКТИКА</span>
          <span class="animation-title delay-1 position">
            МЕНІНГОКОКОВОЇ ІНФЕКЦІЇ ГРУПИ
            <span class="content__title-letter">В</span>
            <span class="content__title-border relative">&nbsp;<span class="hover-container"><svg class="popup-icon"
                                                                                                   width="32"
                                                                                                   height="32"
                                                                                                   viewBox="0 0 32 32"
                                                                                                   fill="none"
                                                                                                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.6846 1.37891C15.2186 1.13597 16.7814 1.13597 18.3154 1.37891C19.8497 1.62191 21.3366 2.10533 22.7207 2.81055C24.1047 3.51574 25.3695 4.4339 26.4678 5.53223C27.5661 6.63055 28.4843 7.89535 29.1895 9.2793C29.8947 10.6634 30.3781 12.1503 30.6211 13.6846C30.864 15.2186 30.864 16.7814 30.6211 18.3154C30.3781 19.8497 29.8947 21.3366 29.1895 22.7207C28.4843 24.1047 27.5661 25.3695 26.4678 26.4678C25.3695 27.5661 24.1047 28.4843 22.7207 29.1895C21.3366 29.8947 19.8497 30.3781 18.3154 30.6211C16.7814 30.864 15.2186 30.864 13.6846 30.6211C12.1503 30.3781 10.6634 29.8947 9.2793 29.1895C7.89535 28.4843 6.63055 27.5661 5.53223 26.4678C4.4339 25.3695 3.51574 24.1047 2.81055 22.7207C2.10533 21.3366 1.62191 19.8497 1.37891 18.3154C1.13597 16.7814 1.13597 15.2186 1.37891 13.6846C1.62191 12.1503 2.10533 10.6634 2.81055 9.2793C3.51574 7.89535 4.4339 6.63055 5.53223 5.53223C6.63055 4.4339 7.89535 3.51574 9.2793 2.81055C10.6634 2.10533 12.1503 1.62191 13.6846 1.37891Z"
                    stroke="#8C47CC" stroke-width="2"/>
                <circle cx="16" cy="9" r="1" fill="#8C47CC"/><path
                d="M16 13V23.8529" stroke="#8C47CC" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"
                stroke-linejoin="round"/>
              </svg>

              <span class="popup-text">В означає профілактику менінгококової інфекції типу “В”
              <svg class="close-popup" width="20" height="20" viewBox="0 0 20 20" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.61133 1.23242C9.53136 1.0867 10.4686 1.0867 11.3887 1.23242C12.3087 1.37814 13.2003 1.66793 14.0303 2.09082C14.8601 2.51369 15.6187 3.06406 16.2773 3.72266C16.9359 4.38125 17.4863 5.13986 17.9092 5.96973C18.3321 6.79969 18.6219 7.6913 18.7676 8.61133C18.9133 9.53136 18.9133 10.4686 18.7676 11.3887C18.6219 12.3087 18.3321 13.2003 17.9092 14.0303C17.4863 14.8601 16.9359 15.6187 16.2773 16.2773C15.6187 16.9359 14.8601 17.4863 14.0303 17.9092C13.2003 18.3321 12.3087 18.6219 11.3887 18.7676C10.4686 18.9133 9.53136 18.9133 8.61133 18.7676C7.6913 18.6219 6.79969 18.3321 5.96973 17.9092C5.13986 17.4863 4.38125 16.9359 3.72266 16.2773C3.06406 15.6187 2.51369 14.8601 2.09082 14.0303C1.66793 13.2003 1.37814 12.3087 1.23242 11.3887C1.0867 10.4686 1.0867 9.53136 1.23242 8.61133C1.37814 7.6913 1.66793 6.79969 2.09082 5.96973C2.51369 5.13986 3.06406 4.38125 3.72266 3.72266C4.38125 3.06406 5.13986 2.51369 5.96973 2.09082C6.79969 1.66793 7.6913 1.37814 8.61133 1.23242Z"
                    stroke="#FF8DBE" stroke-width="2"/>
                <path d="M6.49805 6.45325L13.5041 13.4593" stroke="#FF8DBE" stroke-width="2" stroke-miterlimit="10"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M13.5039 6.44885L6.49786 13.4549" stroke="#FF8DBE" stroke-width="2" stroke-miterlimit="10"
                      stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </span>
</span>
            </span>
          </span>
          <span class="animation-title delay-2 position2">доступна В УКРАЇНІ!</span>
        </h1>

      </div>

      <div class="content__right">
        <div
            v-for="(item, index) in contentItems"
            :key="index"
            :class="`scrolled fade-in-top-visible delay-${ index + 1}-mob-custom content__item content__item--card${index + 1}`">
          <h3 class="content__item-title" v-html="item.title"></h3>
          <p class="content__item-text" v-html="item.body"></p>
        </div>
      </div>

      <div class="content__arrow">
        <nextArrow :link="`/#section2`"/>
      </div>
    </div>

  </section>
</template>

<style scoped lang="scss">

.content {
  padding-top: 48px;
  padding-bottom: 15vh;

  min-height: calc(100vh - 80px);

  align-items: center;
  justify-content: space-between;

  .position2 {
    position: relative;
    z-index: 1 !important;
  }

  .position {
    position: relative;
    z-index: 3;
  }

  .delay-2 {
    position: relative;
    z-index: 1;
  }

  .relative {
    position: relative;
  }

  .popup-text {
    position: absolute;
    left: calc(100% + 10px);
    top: -4px;

    background-color: white;

    padding: 10px;
    color: #022E4E;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 132%;
    z-index: 999999;

    min-width: 240px;

    border-radius: 10px;
    letter-spacing: initial;
    text-transform: initial;
    pointer-events: none;

    opacity: 0;
    text-align: left;

    .close-popup {
      position: absolute;
      right: 8px;
      top: 8px;
      display: none;
    }

    &::before {
      content: '';
      position: absolute;
      left: -8px;
      top: 50%;
      transform: translateY(-50%);

      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
      border-right: 8px solid white;
    }

    &::after {
      content: '';
      position: absolute;
      right: -8px;
      top: 50%;
      transform: translateY(-50%);

      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
      border-left: 8px solid white;
      display: none;
    }

    @media screen and (max-width: 1024px) {
      left: initial;
      right: calc(100% + 10px);
      min-width: 260px;
      &:before {
        display: none;
      }
      &:after {
        display: block;
      }
    }

    @media screen and (max-width: 600px) {
      display: block;
      right: initial;

      left: calc(50% - 25px);
      top: 50%;
      transform: translate(-50%, -50%);

      &:after {
        display: none;
      }
      .close-popup {
        display: block;
      }
    }
  }

  .hover-container {
    position: absolute;
    left: calc(100% - 10px);
    top: 0;

    &:hover {
      @media screen and (min-width: 1024px) {
        cursor: pointer;
      }

      .popup-icon {
        path, circle {
          //fill: #FF8DBE;
          stroke: #FF8DBE
        }
      }

      .popup-text {
        opacity: 1;
      }
    }
  }

  .popup-icon {
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;

    display: inline-block;
    position: relative;
    top: -9px;
    @media screen and (max-width: 1024px) {
      width: 20px;
      height: 20px;
      min-width: 20px;
      min-height: 20px;
      top: -10px;

    }
    @media screen and (max-width: 600px) {
      top: 0;
    }

  }

  &__left {
    max-width: 590px;
    width: 100%;
    margin-right: 10px;
    position: relative;
    z-index: 10;
  }

  &__right {
    max-width: 590px;
    width: 100%;
    margin-left: 10px;
  }

  &__message {
    display: flex;
    align-items: center;

    &-icon {
      width: 120px;
      margin-right: 16px;
    }

    &-text {
      color: #393939;
      font-size: 20px;
      font-weight: 300;
      line-height: 132%;
      letter-spacing: 0.4px;

      max-width: 294px;
      width: 100%;


    }

    &-accent {
      font-size: 20px;
      font-weight: 600;


    }
  }

  &__title {
    color: var(--black-text, #393939);

    font-size: 52px;
    font-weight: 600;
    line-height: 120%;
    letter-spacing: 2.08px;
    text-transform: uppercase;

    margin-top: 28px;

    b {
      font-weight: 600;

    }

    &-letter {
      font-weight: 600;
      line-height: 116%;

    }

    &-border {
      font-weight: 100;
      line-height: 116%;
    }
  }

  &__btn {
    width: 276px;
    margin-top: 48px;
  }

  &__item {
    border-radius: 24px;

    width: 285px;
    height: 285px;

    padding-left: 24px;
    padding-right: 24px;

    display: flex;
    flex-direction: column;
    position: relative;

    &--card1 {
      z-index: 1;
      background-image: url("@/assets/img/section1/card-1.svg");
      background-repeat: no-repeat;
      background-size: 210px;
      background-position: right top;
      background-color: #AA6DE3;

      padding-bottom: 47px;

      justify-content: flex-end;

      h3 {
        color: white;
      }

      p {
        color: white;
      }
    }

    &--card2 {
      z-index: 2;
      background-color: #FEDF55;
      background-image: url("@/assets/img/section1/card-2.svg");
      background-repeat: no-repeat;
      background-size: 227px;
      background-position: right calc(100% + 2px);

      padding-top: 27px;

      margin-top: -155px;
      margin-right: 0;
      margin-left: auto;

      h3 {
        color: #393939;
        text-align: center;
        font-size: 20px;

        @media screen and (max-width: 1020px) {
          font-size: 16px;

        }
      }

      p {
        color: #393939;
        text-align: center;
        max-width: 200px;

        margin-left: auto;
        margin-right: auto;
      }
    }

    &--card3 {
      z-index: 3;
      background-color: #FF8DBE;
      background-image: url("@/assets/img/section1/card-3.svg");
      background-repeat: no-repeat;
      background-size: 186px;
      background-position: left bottom;

      align-items: flex-end;

      padding-top: 28px;
      margin-left: 16%;
      margin-top: -165px;

      h3 {
        color: #393939;
        text-align: right;
        max-width: 180px;

        br {
          display: none;
        }
      }

      p {
        color: #393939;
        text-align: right;
        max-width: 148px;
      }
    }

    &-title {
      color: #FFF;
      font-size: 24px;
      font-weight: 700;
      line-height: 120%;
      letter-spacing: 0.96px;
      text-transform: uppercase;

    }

    &-text {
      color: #FFF;
      font-size: 16px;
      font-weight: 400;
      line-height: 132%;

      :deep(b) {
        font-weight: 800;

      }
    }
  }

  &__arrow {
    position: absolute;
    bottom: calc(15vh);

    right: 0;
    left: 0;
    margin-left: auto;
    margin-right: auto;

    width: 64px;
  }
}

@media screen and (max-width: 1280px) {
  .content {

    &__item {


      &--card1 {


        h3 {
        }

        p {
        }
      }

      &--card2 {

        margin-left: 255px;

        h3 {
        }

        p {
        }
      }

      &--card3 {
        margin-top: -110px;

        h3 {
        }

        p {
        }
      }

      &-title {

      }

      &-text {

        b {
        }
      }
    }

  }
}

@media screen and (max-width: 1180px) {
  .content {

    &__item {
      width: 235px;
      height: 235px;
      padding: 20px;

      &--card1 {

        background-size: 173px;

        h3 {
        }

        p {
        }
      }

      &--card2 {
        background-size: 179px;
        align-items: center;
        margin-left: 215px;
        margin-top: -134px;

        h3 {
        }

        p {
          max-width: 170px;

        }
      }

      &--card3 {
        background-size: 147px;

        margin-top: -81px;

        h3 {
        }

        p {
        }
      }

      &-title {
        font-size: 20px;

      }

      &-text {
        font-size: 14px;

        b {
        }
      }
    }

  }
}

@media screen and (max-width: 1020px) {
  .content {

    padding-top: 32px;

    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    &__left {
      max-width: 1024px;
      margin-right: 0;
    }

    &__right {
      max-width: 1024px;
      width: calc(100% + 20px);
      margin-left: -10px;
      margin-right: -10px;
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      margin-top: 70px;


    }

    &__message {
      justify-content: center;

      &-icon {
      }

      &-text {

      }

      &-accent {
      }
    }

    &__title {


      margin-top: 28px;

      text-align: center;
      font-size: 48px;
      line-height: 116%;
      letter-spacing: 1.92px;
      max-width: 580px;
      margin-left: auto;

      margin-right: auto;

      &-letter {
      }

      &-border {
      }
    }

    &__btn {
      width: 276px;
      margin-top: 24px;
      margin-left: auto;
      margin-right: auto;
    }

    &__item {
      border-radius: 24px;

      width: 216px;
      height: 216px;

      padding-left: 20px;
      padding-right: 20px;

      margin: 10px;

      &--card1 {
        z-index: 1;
        order: 2;
        background-size: 147px auto;

        padding-bottom: 20px;
        padding-top: 20px;

        justify-content: flex-end;

        h3 {
        }

        p {
        }
      }

      &--card2 {
        background-size: 124px;
        order: 3;

        padding-top: 20px;

        h3 {
        }

        p {
        }
      }

      &--card3 {
        background-size: 124px;
        order: 1;

        h3 {
        }

        p {
          max-width: 120px;
        }
      }

      &-title {
        font-size: 18px;
        line-height: 132%;
        letter-spacing: 0.72px;
      }

      &-text {
        font-size: 14px;
        font-weight: 400;
        line-height: 132%;

        b {
          font-weight: 800;

        }
      }
    }

    &__arrow {
      display: none;
    }
  }
}

@media screen and (max-width: 600px) {
  .content {
    min-height: 1px;

    padding-top: 16px;
    padding-bottom: 0;
    padding-left: 8px;
    padding-right: 8px;

    &__left {
    }

    &__right {
      margin-top: 40px;
    }

    &__message {

      &-icon {
        width: 76px;
      }

      &-text {
        font-size: 14px;
        line-height: 124%;
        max-width: 213px;
      }

      &-accent {
        font-size: 14px;
      }
    }

    &__title {

      font-size: 28px;
      line-height: 120%; /* 33.6px */
      max-width: 297px;

      &-letter {
        font-size: 28px;
        font-weight: 600;


      }

      &-border {
        font-size: 28px;
        font-weight: 600;

      }
    }

    &__btn {
      width: 248px;
      margin-top: 24px;
    }

    &__item {
      //margin-left: 0;
      //margin-right: 0;


      &--card1 {

        h3 {
        }

        p {
        }
      }

      &--card2 {


        h3 {
        }

        p {
        }
      }

      &--card3 {

        h3 {
        }

        p {
        }
      }

      &-title {
      }

      &-text {

        b {
        }
      }
    }

    &__arrow {
    }
  }
}

@media screen and (max-width: 535px) {
  .content {

    &__left {
    }

    &__right {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }

    &__message {

      &-icon {
      }

      &-text {
      }

      &-accent {
      }
    }

    &__title {


      &-letter {

      }

      &-border {

      }
    }

    &__btn {
    }

    &__item {
      max-width: 296px;

      width: 100%;
      margin: 0 auto 16px auto;
      height: 160px;
      padding: 20px;

      &--card1 {

        background-size: 155px;
        background-position-y: -11px;

        h3 {
        }

        p {
          max-width: 176px;

        }
      }

      &--card2 {
        background-size: 172px;
        background-position: 7px 130%;

        margin-bottom: 0;

        h3 {
          text-align: right;
          margin-left: auto;
          margin-right: 0;
        }

        p {
          text-align: right;
          max-width: 120px;
          margin-left: auto;

          margin-right: 0;
        }
      }

      &--card3 {

        background-size: 123px;
        background-position-y: 0;

        h3 {
          max-width: 211px;

          br {
            display: block;
          }
        }

        p {
          max-width: 130px;
        }
      }

      &-title {
      }

      &-text {

        b {
        }
      }
    }

    &__arrow {
    }
  }
}
</style>